import "./SkipLink.scss";

interface Props {
  text: string;
}

const SkipLink = ({ text }: Props) => (
  <a className="skip-link" href="#main-content">
    {text}
  </a>
);

export default SkipLink;
